var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "12px / info_alt_dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 12C7.18669 12 8.34672 11.6481 9.33342 10.9888C10.3201 10.3295 11.0891 9.39246 11.5433 8.2961C11.9974 7.19975 12.1162 5.99335 11.8847 4.82946C11.6532 3.66557 11.0818 2.59648 10.2426 1.75736C9.40352 0.918247 8.33443 0.346802 7.17054 0.115291C6.00665 -0.11622 4.80025 0.00259976 3.7039 0.456725C2.60754 0.910851 1.67047 1.67989 1.01118 2.66658C0.351894 3.65328 0 4.81331 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM6 2.248C6.15822 2.248 6.3129 2.29492 6.44446 2.38283C6.57601 2.47073 6.67855 2.59567 6.7391 2.74186C6.79965 2.88804 6.8155 3.04889 6.78463 3.20407C6.75376 3.35926 6.67757 3.50181 6.56568 3.61369C6.4538 3.72557 6.31126 3.80176 6.15607 3.83263C6.00089 3.8635 5.84003 3.84766 5.69385 3.78711C5.54767 3.72656 5.42273 3.62402 5.33482 3.49246C5.24692 3.3609 5.2 3.20623 5.2 3.048C5.2 2.83583 5.28428 2.63235 5.43431 2.48232C5.58434 2.33229 5.78783 2.248 6 2.248ZM5.2 6C5.2 5.78783 5.28428 5.58434 5.43431 5.43432C5.58434 5.28429 5.78783 5.2 6 5.2C6.21217 5.2 6.41565 5.28429 6.56568 5.43432C6.71571 5.58434 6.8 5.78783 6.8 6V9.2C6.8 9.41217 6.71571 9.61566 6.56568 9.76569C6.41565 9.91571 6.21217 10 6 10C5.78783 10 5.58434 9.91571 5.43431 9.76569C5.28428 9.61566 5.2 9.41217 5.2 9.2V6Z",
    fill: "#001A3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDark);
export default __webpack_public_path__ + "static/media/info_dark.3e99dd4b0e2c01476ae07d256317e64b.svg";
export { ForwardRef as ReactComponent };